module.exports = __webpack_public_path__ + "img/WA-XXX.f00c4499.png";